import React, {Component} from "react";
import { Helmet } from 'react-helmet';
import './Dietplan.css';
import * as actions from '../Actions';
import { fetchInitialData } from "../../fetchData";
import DietPlanSlider from '../common/DietPlanSlider';
import DietPlanArticle from '../common/DietPlanArticle';
import Right from '../../right/Right';
import Service from '../../service/Service';
const service = new Service();
class Dietplan extends Component {
    constructor(props) {
        super(props);
        let initialData = {};
        let stageResponse = [];
        let articlesData = [];

        if (__isBrowser__ && window.__initialData__ && window.__initialData__['initialData']) {
            initialData = window.__initialData__['initialData'];
            if (window.__initialData__['initialData']['stageResponse']) {
                stageResponse = window.__initialData__['initialData']['stageResponse'];
            }
            if (window.__initialData__['initialData']['result']) {
                articlesData = window.__initialData__['initialData']['result'];
            }
            delete window.__initialData__;

        } else {
            if (props.staticContext && props.staticContext.initialData && props.staticContext.initialData['initialData']) {
                initialData = props.staticContext.initialData['initialData'];
                if (props.staticContext.initialData['initialData']['stageResponse']) {
                    stageResponse = props.staticContext.initialData['initialData']['stageResponse'];
                }
                if (props.staticContext.initialData['initialData']['result']) {
                    articlesData = props.staticContext.initialData['initialData']['result'];
                }
            }
        }
        this.state = {
            initialData: initialData,
            stageResponse: stageResponse,
            articlesData: articlesData,
            currentstage: 1,
            currentstageWeek: '',
            reloadflag: 1,
            count:1,
            myactiveStage: '',
            shareurl: '',
            cardList: '',
            cardListmonth: '',
            weekList: '',
            selectedChild: '',
            selectchildName: '',
            childListData: '',
            cardsTotalHeight: '',
            relcountplus: '',
            relcount: '',
            isshowDropdown:false,
            flag:0,
            isApp:false,
            IsExpected: false
        }
    }
    static initialAction(reqUrl, ftk, authData, uId, childData) {
        let childinfo = childData['UserChildList'];
        console.log("childinfo"+childinfo);
        
        let postdietarr = [];
        if (childinfo) {
            postdietarr = childData['UserChildList'];
        } else {
            postdietarr = [];
        }
        if (postdietarr.length > 1) {
            if (postdietarr[0]['IsExpected']) {
                childinfo = [{
                    "childid": postdietarr[1]['ChildId'],
                    "childname": postdietarr[1]['ChildName'],
                    "dob": postdietarr[1]['DOB'],
                    "childgender": postdietarr[1]['Gender'],
                    "childphoto": postdietarr[1]['childPhoto']
                }];
            } else {
                childinfo = [{
                    "childid": postdietarr[0]['ChildId'],
                    "childname": postdietarr[0]['ChildName'],
                    "dob": postdietarr[0]['DOB'],
                    "childgender": postdietarr[0]['Gender'],
                    "childphoto": postdietarr[0]['childPhoto']
                }];
            }
        }
        else if (postdietarr.length == 1) {
            if (postdietarr[0]['IsExpected']) {
                childinfo = [];
            } else {
                childinfo = [{
                    "childid": postdietarr[0]['ChildId'],
                    "childname": postdietarr[0]['ChildName'],
                    "dob": postdietarr[0]['DOB'],
                    "childgender": postdietarr[0]['Gender'],
                    "childphoto": postdietarr[0]['childPhoto']
                }];
            }
        }        
        var header = {
            'Content-Type': 'application/json',
            'ftk':  ftk,
            'uid': uId,
            'access-token': authData['access-token'],
            'user-agent': global.userAgent,
            'isdesktop': global.isdesktop
        }
        var url = global.api_url + "dietplan/getdietplansummary";
        let body = JSON.stringify({ 
            "childinfo": childinfo,
            "pageNo": 1,
            "pageSize": 10,
            "stageid": ""
        })
        return fetchInitialData(url, JSON.stringify(header), body);
    }
    componentDidMount() {

        console.log("initialData===================>", this.state.initialData);
        console.log("initialData===================>", this.state.articlesData);
        
        if (this.props.location.search.includes('from=app')) {
            this.setState({ isApp: true });
        }
        document.addEventListener("click", this.domClick);
        this.state.childListData = global.userAry['childData']['UserChildList'];
        if (this.state.childListData) {
             if (this.state.childListData.length > 1) {
                if (this.state.childListData[0]['IsExpected']) {
                    this.state.selectchildName = this.state.childListData[1] && this.state.childListData[1]['ChildName'] ? this.state.childListData[1]['ChildName'] : '';
                    this.state.selectedChild = this.state.childListData[1] && this.state.childListData[1]['ChildId'] ? this.state.childListData[1]['ChildId'] : '';
                } else {
                    this.state.selectchildName = this.state.childListData[0] && this.state.childListData[0]['ChildName'] ? this.state.childListData[0]['ChildName'] : '';
                    this.state.selectedChild =  this.state.childListData[0] && this.state.childListData[0]['ChildId'] ? this.state.childListData[0]['ChildId'] : '';
                }
            } else if (this.state.childListData.length == 1) {
                if (this.state.childListData[0]['IsExpected']) {
                    this.state.selectchildName = '';
                    this.state.selectedChild = '';
                } else {
                    this.state.selectchildName = this.state.childListData[0] && this.state.childListData[0]['ChildName'] ? this.state.childListData[0]['ChildName'] : '';
                    this.state.selectedChild = this.state.childListData[0] && this.state.childListData[0]['ChildId'] ? this.state.childListData[0]['ChildId'] : '';
                }
            }else {
                this.state.selectchildName = '';
                this.state.selectedChild = '';
            }
        }
        if (window.innerWidth > 767) {
            this.CardScroll = this.CardScroll.bind(this);
            document.querySelector(".card_container").addEventListener("scroll", this.CardScroll, false);
        } else {
            this.CardScroll = this.CardScroll.bind(this);
            window.addEventListener("scroll", this.CardScroll, false);
        }
        if (global.userAry['IsExpected']) {
            this.setState({ IsExpected: true });
        } else {
            this.setState({ IsExpected: false });
        }
        if (navigator.onLine) {
            if (!this.state.initialData || (this.state.initialData && Object.keys(this.state.initialData).length < 1)) {
                service.showLoader();
                this.getDietplanBabyData(this.state.selectedChild);
                // this.landdingPage();

            } else {
                localStorage.setItem('DietplanBabyData', JSON.stringify(this.state.initialData));
                // this.landdingPage();
                this.selectChild(this.state.selectedChild);
                // this.getDietplanBabyData(this.state.selectedChild);
            }
        } else {
            if (localStorage.getItem('DietplanBabyData')) {
                this.setState({
                    initialData: JSON.parse(localStorage.getItem('DietplanBabyData')),
                    stageResponse: JSON.parse(localStorage.getItem('DietplanBabyData'))['stageResponse'] ? JSON.parse(localStorage.getItem('DietplanBabyData'))['stageResponse'] : [],
                    articlesData: JSON.parse(localStorage.getItem('DietplanBabyData'))['result']
                });
                // this.landdingPage();
            }
            service.hideLoader();
        }
    }
    getDietplanBabyData(childid) {
        console.log("getDietplanBabyData=============>",childid);
       let childinfo = global.userAry['childData'] && global.userAry['childData']['UserChildList'] ? global.userAry['childData']['UserChildList'] : '';
        let childname,dob,childgender,childphoto;
        if(childid && childinfo.length > 0){
            console.log("selectChild=====>",childid)
                for (let i = 0; i < childinfo.length; i++) {
                    if (childinfo[i]['ChildId'] == childid) {
                        childgender = childinfo[i]['Gender'];
                        dob = childinfo[i]['DOB'];
                        childname = childinfo[i]['ChildName'];
                        childphoto = childinfo[i]['childPhoto'];
                    }
                }
                childinfo = [{
                "childid": childid,
                "childgender": childgender,
                "dob": dob,
                "childname": childname,
                "childphoto": childphoto
            }];
        }else{
            childinfo = [{
                "childid": '',
                "childgender": '',
                "dob": '',
                "childname": '',
                "childphoto": ''
            }];
    }
        var postData = {
            "childinfo": childinfo,
            "pageNo": 1,
            "pageSize": 10,
            "stageid": ""
        };
        // console.log("postData==========>", postData);
        // var url = global.api_url + "dietplan/getdietplansummaryweek";
        // var url = global.api_url + "dietplan/getdietplansummary";
        var url = global.api_ci_url + "DietplanBaby/getDietplanBabyData";
        service.postServiceCall(url, postData).then((json) => {
            console.log("json===========>", json);
            if (json['result']) {
                // console.log("succceeesssss=======>");
                this.setState({
                    initialData: json,
                    stageResponse: json['stageResponse'] ? json['stageResponse'] : [],
                    articlesData: json['result'],
                    selectedChild:childid
                }, () => {
                    this.selectChild(childid);
                });
                localStorage.setItem('DietplanBabyData', JSON.stringify(json));
            }
            service.hideLoader();
        }).catch((error) => {
            console.error(error);
            service.hideLoader();
        });
    }
    // childrenlist() {
    //     if (document.getElementById("myDropdown").style.display == "block") {
    //         document.getElementById("myDropdown").style.display = "none";
    //     } else {
    //         document.getElementById("myDropdown").style.display = "block"
    //     }
    // }
    childrenlist() {
        if (this.state.isshowDropdown === false) {
            this.setState({ isshowDropdown: true })
        } else {
            this.setState({ isshowDropdown: false })
        }
    }
    // calWeekScrollLeft(id) {
    //     var liMargin;
    //     var id = parseInt(id);
    //     var liWidth = document.querySelector('.video_tabs ul li').offsetWidth;
    //     // var liMargin = parseInt(document.querySelector('.video_tabs ul li').style.marginRight);
    //     if ((window).innerWidth < 767) {
    //         liMargin = 8;
    //     } else {
    //         liMargin = 12;
    //     }
    //     return ((liWidth + liMargin) * 4 * (id - 1));
    // }
    addRemoveClass(act){
        if(act!=''){
            for (let i = 0; i < this.state.cardList.length; i++) {
                if (document.querySelector('.act' + i).classList.contains('active')) {
                    document.querySelector('.act' + (i)).classList.remove('active');
                }
            }
            document.querySelector('.act' + (act - 1)).classList.add('active');
        }
        // if(week!=''){
        //     for (let i = 1; i < this.state.weekList.length + 1; i++) {
        //         if (document.querySelector('#week-' + i).classList.contains('active')) {
        //             document.querySelector('#week-' + (i)).classList.remove('active');
        //         }
        //     }
        //     document.querySelector("#week-" + week).classList.add('active');
        // }
    }
    setBlog(left,id,selectedWeek){
            let cards_offset = 0;
            if (document.querySelector('#month-card-' + left) && document.querySelector('#month-card-' + left).offsetTop) {
                cards_offset = document.querySelector('#month-card-' + left).getBoundingClientRect().top + window.scrollY;
                // cards_offset = document.querySelector('#month-card-' + left).offsetTop;
            }
            document.querySelector('.month-slider').scrollLeft = 0;
            let monthSliderPosition = actions.calScrollLeft(id, 19);
            // let weekSliderPosition = this.calWeekScrollLeft(id);
            if ((window).innerWidth > 767) {
                this.state.cardsTotalHeight = actions.calScrollTop(left, id, 15, this);
                document.querySelector('.month-slider').scrollLeft = monthSliderPosition;
                // document.querySelector('.video_tabs').scrollLeft = weekSliderPosition;
                if (selectedWeek == 1) {
                    document.querySelector(".card_container").scrollTop = 0;
                } else {
                    document.querySelector(".card_container").scrollTop = this.state.cardsTotalHeight;
                }
                return !1
            } else {
                document.querySelector('.month-slider').scrollLeft = monthSliderPosition - 15;
                // document.querySelector('.video_tabs').scrollLeft = weekSliderPosition;
                if (selectedWeek == 1) {
                    document.querySelector("html,body").scrollTop = 0;
                }else {
                    if(this.state.isApp){
                        document.querySelector("html,body").scrollTop = (cards_offset-210);
                    }else{
                        document.querySelector("html,body").scrollTop = (cards_offset-265);
                    }
                }
                return !1
            }
    }

    selectChild(childid) {
        // this.state.cardList = document.querySelectorAll('.tablink');
        // this.state.cardListmonth = document.querySelectorAll('.month-old');
        this.setState({
            cardList : document.querySelectorAll('.tablink'),
            cardListmonth : document.querySelectorAll('.month-old')
        });
        // this.state.weekList = document.querySelectorAll('.video_tabs ul li');
        console.log("childid=============>", childid);
        setTimeout(()=>{
        if (childid != '') {
            document.getElementById("myDropdown").style.display = "none";
            var selected_child;
            if(document.getElementById(childid)){
                selected_child = document.getElementById(childid).children['1'].innerText
            }
            document.querySelector('.childname').innerHTML = selected_child;
            for (let i = 0; i < document.querySelectorAll('.current_child').length; i++) {
                document.querySelectorAll('.current_child')[i].style.visibility = "hidden";
                document.querySelectorAll('.children')[i].style.background="";
            }
            document.getElementById(childid).style.background = "#f5f5f5";
            document.getElementById(childid).lastChild.style.visibility = "visible";
        }
        // var currentstage = 1;
        if (this.state.stageResponse && this.state.stageResponse.length > 0) {
            this.state.currentstageWeek = this.state.initialData['currentStageId'];

            // for (var i = 0; i <= 94; i++) {
            //     console.log("currentStageId========>", this.state.currentstageWeek);
            //     if (this.state.currentstageWeek == this.state.stageResponse[i].stageAgeUnit) {
            //         var currentmonth = this.state.stageResponse[i].stageName;
            //         var currentmonthno = currentmonth.split(" ");
            //         this.state.currentstage = currentmonthno[0];
            //     }
            // }
            this.state.currentstage = this.state.currentstageWeek;

        }
        if (this.state.initialData['currentStageId'].length > 0) {
            this.state.currentstage = this.state.initialData['currentStageId'];
        }
        let id = this.state.currentstage;

        // let id = parseInt(this.state.currentstage) - 5;
        document.querySelector('.month-slider').scrollLeft = 0;
        let monthSliderPosition = actions.calScrollLeft(id, 19);
        // let weekSliderPosition = this.calWeekScrollLeft(id);
        var currentWeek = parseInt(this.state.currentstageWeek);
        // var week = currentWeek % 4;
        // if (week == 0) {
        //     week = 4;
        // }
        var left = parseInt(id) + 5;
        var rightd = parseInt(id) - 1;

        var cards_offset = 0;
        if (document.querySelector('#month-card-' + left).offsetTop) {
            // cards_offset = document.querySelector('#month-card-' + left).offsetTop;
            cards_offset = document.querySelector('#month-card-' + left).getBoundingClientRect().top + window.scrollY;
        }
        // var cardsTotalHeight = calScrollTop(left, rightd, id);
        // var horiztallength;

        this.addRemoveClass(id);
        console.log("currentWeek======>", currentWeek);
        actions.changeTabTextColor(this);
        if ((window).innerWidth < 767) {
            document.querySelector('.month-slider').scrollLeft = monthSliderPosition - 15;
            // document.querySelector('.video_tabs').scrollLeft = weekSliderPosition;
            if (id == 1) {
                document.querySelector('html,body').scrollTop = 0
            } else if (this.state.reloadflag == 1) {
                this.state.reloadflag = 2;
                document.querySelector('html,body').scrollTop = cards_offset-340;
            } else {
                document.querySelector('html,body').scrollTop = cards_offset-265;
            }
        } else {
            this.state.cardsTotalHeight = actions.calScrollTop(left, id, 15, this);
            document.querySelector('.month-slider').scrollLeft = monthSliderPosition;
            // document.querySelector('.video_tabs').scrollLeft = weekSliderPosition;
            if (this.state.currentstage == "1") {
                document.querySelector('.card_container').scrollTop = 0
            } else {
                document.querySelector('.card_container').scrollTop = this.state.cardsTotalHeight;
            }
        }
        }, 20);
        if (window.innerWidth < 768) {
            actions.removeSelfClass('M24_pink', 'M15_fc88af');
            actions.removeSelfClass('B20_42', 'M15_42');
            actions.removeSelfClass('M14_42', 'M13_42');
            actions.removeSelfClass('R14_9e', 'R11_9e');
            actions.removeSelfClass('R16_42', 'R14_42');
        }
    }
    // weekclick(e, id) {
    //     if (navigator.onLine) {
    //         var selectedWeek = parseInt(id);
    //         var month;
    //         var month_chk_float = selectedWeek / 4;
    //         var month_chk = Math.floor(month_chk_float);
    //         var week = selectedWeek % 4;
    //         if (week == 1 || week == 2 || week == 3) {
    //             month = month_chk + 1;
    //         }
    //         if (week == 0) {
    //             week = 4;
    //             month = month_chk;
    //         }
    //         var left = ((parseInt(month) - 1) * 4 + (week - 1)) + 6;
    //         this.setBlog(left,month,selectedWeek);
    //         this.addRemoveClass('',id);
    //     } else {
    //         service.hideLoader();
    //         service.showAlert("Please Check Internet Connection!!!");
    //         return false;
    //     }
    // }
    tablink(e, id) {
        if (navigator.onLine) {
            this.addRemoveClass(id);
            actions.changeTabTextColor(this);
            var left = parseInt(id) + 5;;
            this.setBlog(left,id,id);
        } else {
            service.hideLoader();
            service.showAlert("Please Check Internet Connection!!!");
            return false;
        }
    }
    isInViewport(el) {
            var elementTop = el.getBoundingClientRect().top + window.scrollY;
            var elementBottom = elementTop + el.offsetHeight;
            var viewportTop = window.pageYOffset;
            if(window.innerHeight > 710 && window.innerWidth < 767){
                var viewportBottom = viewportTop + window.innerHeight/2;
            }else{
                var viewportBottom = viewportTop + window.innerHeight;
            }
            return elementBottom > viewportTop && elementTop < viewportBottom
    }
    CardScroll() {
            // console.log("this.state.reloadflag==============>");
            let id;
            for (var i = 6; i <= 24; i++) {
                let flag = this.isInViewport(document.querySelector("#month-card-" + i));
                if (flag) {
                    var recdMonthId = document.querySelector('#month-card-' + i).id;
                    var monthId = recdMonthId.slice("11");
                    var mnth = parseInt(monthId) - 5;
                    this.addRemoveClass(mnth);
                    actions.changeTabTextColor(this);
                    this.state.myactiveStage = document.querySelector('.act' + (mnth - 1)).offsetLeft;
                    id = i - 5;
                    document.querySelector('.month-slider').scrollLeft = 0;
                    var monthSliderPosition = actions.calScrollLeft(mnth, 19);
                    // var weekSliderPosition = this.calWeekScrollLeft(mnth);
                    if (window.innerWidth > 767) {
                        document.querySelector('.month-slider').scrollLeft = monthSliderPosition;
                    } else {
                        document.querySelector('.month-slider').scrollLeft = monthSliderPosition-15;
                    }
                    // document.querySelector('.video_tabs').scrollLeft = weekSliderPosition;

                }
                else if (this.isInViewport(document.querySelector("#month-card-" + i))) {
                    var week = i - 5;
                    // this.addRemoveClass('',week);
                }
            }
            if (window.innerWidth < 767) {
                this.state.count=this.state.count+1;
                // if(this.state.count=="3"){
                //     this.lastCall();
                // }
                // if(this.state.count>5){
                //     this.state.reloadflag=3;
                //     // this.weekclick("",24);
                // }
                // if(this.state.reloadflag=="2"){
                //     let id = parseInt(this.state.currentstage) - 5;
                //     var currentWeek = parseInt(this.state.currentstageWeek);
                //     var week = currentWeek % 4;
                //     if (week == 0) {
                //         week = 4;
                //     }
                
                //     var left = ((parseInt(id) - 1) * 4 + (week - 1)) + 6;
                //     var cards_offset = 0;
                //     if (document.querySelector('#month-card-' + left).offsetTop) {
                //         cards_offset = document.querySelector('#month-card-' + left).offsetTop;
                //         // cards_offset = document.querySelector('#month-card-' + left).getBoundingClientRect().top + window.scrollY;
                //     }
                //     setTimeout(() => {
                //         if(document.querySelector('.left.active').id.split("-")[1]!=currentWeek){
                //             //    this.weekclick('',currentWeek);
                //             // this.getDietplanBabyData(3861841);
                //             document.querySelector('html,body').scrollTop = cards_offset;
                //         }
                //     }, 1000);
                // }
            if (window.scrollY > 0) {
                    document.querySelector(".diet_top").classList.add("sticky_diet_top");
                    document.querySelector('.card_container').style.top = '125px';
                } else {
                    document.querySelector(".diet_top").classList.remove("sticky_diet_top");
                    document.querySelector('.card_container').style.top = '0';
                }
                if (this.state.isApp) {
                    document.querySelector(".diet_top").classList.add("isAppCls");
                    document.querySelector(".diet_top").classList.remove("sticky_diet_top");
                    if(week==1){
                        document.querySelector('.card_container').style.top = '200px';
                    }
                }
            }
    }
    shareOn(id) {
        console.log("share============>",id.target.nextSibling);
        let ary=document.querySelectorAll(".sharing-options");
        for(var i=0;i<ary.length;i++){
            ary[i].style.display = 'none';
        }
        if (window.innerWidth < 767) {
            id.target.nextSibling.style.display = 'block';
            document.getElementsByClassName('share-overlay')[0].style.display = 'block';
        }
        id.target.nextSibling.style.display = 'block';
    }
    likeArticle(artiID, stageId, e, likecount, viewcnt, arttitle) {
        console.log("json===============>");
        let cls = e.target;
        if (global.ftk !== '') {
            service.showLoader();
            var postData = {
                "stageId": stageId,
                "articleId": artiID,
                "actionStatus": "1"
            }
            var url = global.api_ci_url + "DietplanBaby/getLikeAction";
            // var url = global.api_url + "dietplan/savearticlelikeaction";
            service.postServiceCall(url, postData).then((json) => {
                // console.log("json===============>",json);
                service.hideLoader();
                // console.log("json===============>",json);
                if (json['result'] == "success") {
                    cls.classList.add('active');
                    cls.nextSibling.firstElementChild.innerHTML = (++likecount);
                }

            }).catch((error) => {
                console.error(error);
                service.hideLoader();
            });
            return true;
        } else {
            service.showAlert("Please Login");
            window.location.href = global.loginUrl + '?URL=' + global.currentURL;
            return false;
        }
    }
    changeData(id, type, status) {
        let articlesData = this.state.articlesData;
        articlesData && articlesData.forEach((articles) => {
            if (articles.articleId == id) {
                if (type == "bookmark") {
                    if (parseInt(status) == 1) {
                        // console.log("successss====>",articles.articleId);
                        articles.isBookmarked = true;
                        articles.bookmarkCount = parseInt(articles.bookmarkCount) + 1;
                    } else if (parseInt(status) == 0) {
                        articles.isBookmarked = false;
                        // articles.bookmarkCount = parseInt(video.bookmarkCount) - 1;
                    }
                }
            }
        });
        this.setState({ articlesData: articlesData });
    }
    setBookMark(articleId, status) {
        if (global.ftk != '') {
            service.showLoader();
            var postData = {
                "articleId": articleId,
                "status": status.toString()
            }
            var url = global.api_ci_url + "DietplanBaby/setBookMark";
            service.postServiceCall(url, postData).then((json) => {
                if (json['msg'] == "1") {
                    this.changeData(articleId, "bookmark", status);
                }
                service.hideLoader();
            }).catch((error) => {
                console.error(error);
                service.hideLoader();
            });
            return true;
        } else {
            service.showAlert("Please Login");
            window.location.href = global.loginUrl + '?URL=' + global.currentURL;
            return false;
        }
    }
    viewArticle(stageId, articleId, articleUrl, viewc, likec, artNm, e) {
        let postData = {
            "articleId": articleId,
            "post_status": "publish"
        }
        var url = global.api_ci_url + "DietplanBaby/getViewAction";
        // var url = global.api_url + "blogs/getarticlesdetails";
        service.postServiceCall(url, postData).then((json) => {
            if (json['msg'] == "1") {
                window.location.href = articleUrl;
            }
        }).catch((error) => {
            console.error(error);
            service.hideLoader();
        });
    }
    domClick(event) {
        console.log("event Dom========>",event.target)
        if (event.target.classList.contains('share-overlay')) {
            let ary = document.getElementsByClassName('sharing-options');
            for (let i = 0; i < ary.length; i++) {
                ary[i].style.display = 'none';
            }
            if (document.getElementsByClassName('share-overlay')[0]) {
                document.getElementsByClassName('share-overlay')[0].style.display = 'none';
            }
        }
        if (!event.target.classList.contains('children') && (document.querySelector("#myDropdown")!=null && document.querySelector("#myDropdown").style.display=="block" && !event.target.parentNode.parentNode.classList.contains("selected-child"))) {
            document.querySelector("#myDropdown").style.display="none";
        }else {
            return false;
        }
    }
    componentWillUnmount() {
        document.removeEventListener("click", this.domClick);  
    }
    // lastCall(){
    //     console.log("last Call");
    //     var currentWeek = parseInt(this.state.currentstageWeek);
    //     if(this.state.reloadflag=="2" || currentWeek==1){
    //             let id = parseInt(this.state.currentstage);
    //             var week = currentWeek % 4;
    //             if (week == 0) {
    //                 week = 4;
    //             }
             
    //             var left = parseInt(id) + 5;
    //             var cards_offset = 0;
    //             if (document.querySelector('#month-card-' + left).offsetTop) {
    //                 cards_offset = document.querySelector('#month-card-' + left).offsetTop;
    //                 // cards_offset = document.querySelector('#month-card-' + left).getBoundingClientRect().top + window.scrollY;
    //             }
    //             setTimeout(() => {
    //                 if(document.querySelector('.left.active').id.split("-")[1]!=currentWeek){
    //                        this.weekclick('',currentWeek);
    //                     // this.getDietplanBabyData(3861841);
    //                     // document.querySelector('html,body').scrollTop = cards_offset-70;
    //                 }
    //             }, 1000);
    //         }
    // }
    render() {
        let childListData1=global.userAry['childData']['UserChildList'];
        return (
            <main className="main-container pregnancy_dietbaby">
                <Helmet
                    title="Diet Plan/Chart for Babies & Toddlers (6 to 24 Months)"
                    meta={[
                        { "name": "description", "content": "Looking for a perfect diet plan for your child? Here we list out month wise food chart for babies & children with various food ideas, meal plans and recipes." },
                        { "name": "keywords", "content": "diet plan for babies, diet chart for babies, diet plan for kids" },
                        { "name": "atdlayout", "content": "tools_sp" }
                    ]}
                />
                <div className="title">
                    <div className="breadcrumb R11_9e">
                        <span><a href={service.getRedirectUrl("/")} className="R11_9e">Home</a></span>
                        <span className="R11_9e breadcrum_icon" data-icon-font="l"></span>
                        <span><a href={service.getRedirectUrl("/tools")} className="R11_9e">Tools</a></span>
                        <span className="R11_9e breadcrum_icon" data-icon-font="l"></span>
                        <span>Baby & Kids Diet Plan</span>
                    </div>
                    <h1 className="B24_00">Diet Plan (6 Months+) </h1>
                </div>
                <div className="sub-container left">
                    <div className="data-container left">
                        <div className="dietplan-block">
                            <div className="diet_top">
                                {global.ftk == '' || !this.state.selectchildName ?
                                    (<div className="drop-down">
                                        <div className="selected-child">
                                            <div className="M24_pink">
                                                <div className="diet-title">Diet Plan Chart
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                        // for logged in user
                                    ) :
                                    (
                                        <div className="drop-down">
                                            <div className="selected-child" onClick={() => { this.childrenlist() }}>
                                                <div className="M24_pink">
                                                    <div className="diet-title">
                                                        <span className="diet-text">Diet Plan for </span>
                                                        <span className="childname">{this.state.selectchildName}</span>
                                                        <input type="hidden" id="selectedChildId" value={this.state.selectedChild} />
                                                    </div>
                                                    {global.ftk && ((childListData1.length) > 2 || ((childListData1.length == 2) && !this.state.IsExpected)) ? (<span data-icon-font="f" className="M24_pink dropbtn right" ></span>) : null}

                                                </div>
                                            </div>
                                        </div>
                                    )}
                                {global.ftk && (childListData1 && (childListData1.length > 1 && !childListData1[0].IsExpected ) || (childListData1.length > 2) && childListData1[0].IsExpected) ? (
                                    <div className="dropdown">
                                    <div id="myDropdown" className="dropdown-content" style={{ display: (this.state.isshowDropdown ? 'block' : 'none') }}>
                                        {childListData1 && childListData1.map(result =>
                                            (!result.IsExpected) ?
                                            <div key={result.ChildId} className="children" id={result.ChildId} onClick={() => this.getDietplanBabyData(result.ChildId, result.ChildName, result.DOB)} style={{ background: (result.ChildId == this.state.selectedChild ? '#f5f5f5' : '#fff') }} data-id={result.DOB}>
                                                <span className="childPic">
                                                    {result.childPhoto == '' ?
                                                        <img src='https://cdn.fcglcdn.com/brainbees/parenting/img/m/default-img.png' className="childprofPic" data-id={result.DOB}/> :
                                                        <img src={result.childPhoto} />
                                                    }
                                                </span>
                                                <span className="child_name R16_42" data-id={result.DOB}>{result.ChildName}</span>
                                                {(result.ChildId == this.state.selectedChild) ?
                                                    <span className="current_child right" data-icon-font=";"></span> : null
                                                }
                                            </div> : null
                                        )}
                                    </div>
                                </div>
                                ) : null
                                }
                                <DietPlanSlider eleRef={this} Slidedata={this.state.stageResponse} tool={'bd'} />
                                {/* <!-- week slider new --> */}
                                {/* <div className="tab_container left">
                                    <div className="video_tabs left">
                                        <ul className="left">
                                            {this.state.articlesData && this.state.articlesData.length > 0 && this.state.articlesData.map((articlesData, index) =>
                                                <li key={index} className="left" onClick={(e) => { this.weekclick(e, index + 1) }} id={"week-" + (index + 1)} rel={index + 1}>
                                                    <span className="M14_42 mnthweek">{index + 1} Week</span>
                                                </li>
                                            )}
                                        </ul>
                                        <div className="arrows">
                                            <span className="next" onClick={(e) => { actions.slideStage(e, this) }}>
                                                <span data-icon-font="h" className="icon"></span>
                                            </span>
                                            <span className="prev" onClick={(e) => { actions.slideStage(e, this) }}>
                                                <span data-icon-font="g" className="icon"></span>
                                            </span>
                                        </div>
                                    </div>
                                </div> */}
                            </div>
                                <DietPlanArticle eleRef={this} Articledata={this.state.articlesData} tool={'BDU'} />
                        </div>
                    </div>
                </div>
                <Right url={this.props.match.url} />
            </main>
        )

    }
}

export default Dietplan;



// WEBPACK FOOTER //
// src/shared/tools/baby-dietplan/Dietplan.js